/* ==========================================================================
   Mobile Products Carousel JavaScript - Casa Krysthal
   Funcionalidade do carousel de produtos para mobile
   Version: 1.0
   ========================================================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Only run on mobile
  if (window.innerWidth > 768) return;
  
  // Setup para cada categoria
  const categoryProducts = document.querySelectorAll('.category-products');
  
  categoryProducts.forEach(container => {
    const grid = container.querySelector('.products-grid');
    if (!grid) return;
    
    const products = Array.from(grid.querySelectorAll('.product-card'));
    if (products.length === 0) return;
    
    // Reorganizar produtos em pares
    const pairs = [];
    for (let i = 0; i < products.length; i += 2) {
      const pair = document.createElement('div');
      pair.className = 'product-pair';
      
      // Adiciona primeiro produto do par
      pair.appendChild(products[i].cloneNode(true));
      
      // Adiciona segundo produto se existir
      if (products[i + 1]) {
        pair.appendChild(products[i + 1].cloneNode(true));
      } else {
        // Se for ímpar, adiciona um espaço vazio
        const emptyCard = document.createElement('div');
        emptyCard.className = 'product-card-empty';
        pair.appendChild(emptyCard);
      }
      
      pairs.push(pair);
    }
    
    // Limpa grid original e adiciona pares
    grid.innerHTML = '';
    pairs.forEach(pair => grid.appendChild(pair));
    
    // Garante que os links funcionem após a clonagem
    grid.querySelectorAll('.product-link, .buy-button-link').forEach(link => {
      link.style.cursor = 'pointer';
      link.style.pointerEvents = 'auto';
    });
    
    // Adiciona dots de navegação
    const dotsContainer = document.createElement('div');
    dotsContainer.className = 'carousel-dots-container';
    
    const totalPages = pairs.length;
    for (let i = 0; i < totalPages; i++) {
      const dot = document.createElement('button');
      dot.className = 'carousel-dot';
      if (i === 0) dot.classList.add('active');
      dot.setAttribute('data-page', i);
      
      dot.addEventListener('click', function() {
        const pageWidth = grid.offsetWidth;
        grid.scrollTo({
          left: i * pageWidth,
          behavior: 'smooth'
        });
      });
      
      dotsContainer.appendChild(dot);
    }
    
    container.appendChild(dotsContainer);
    
    // Atualiza dots ao fazer scroll
    let scrollTimeout;
    grid.addEventListener('scroll', function() {
      clearTimeout(scrollTimeout);
      scrollTimeout = setTimeout(() => {
        const pageWidth = grid.offsetWidth;
        const currentPage = Math.round(grid.scrollLeft / pageWidth);
        
        dotsContainer.querySelectorAll('.carousel-dot').forEach((dot, index) => {
          dot.classList.toggle('active', index === currentPage);
        });
      }, 100);
    });
    
    // Adiciona indicadores de swipe
    const leftIndicator = document.createElement('div');
    leftIndicator.className = 'swipe-indicator left';
    leftIndicator.innerHTML = '←';
    
    const rightIndicator = document.createElement('div');
    rightIndicator.className = 'swipe-indicator right';
    rightIndicator.innerHTML = '→';
    
    container.appendChild(leftIndicator);
    container.appendChild(rightIndicator);
    
    // Atualiza texto dos botões para categorias específicas
    const categorySection = container.closest('.category-section');
    if (categorySection) {
      const category = categorySection.getAttribute('data-category');
      const colorCategories = ['las', 'linhas', 'barbantes', 'fio-de-malha', 'toalhas', 'havaianas'];
      
      if (colorCategories.includes(category)) {
        const buttons = container.querySelectorAll('.buy-button');
        buttons.forEach(button => {
          button.textContent = 'MAIS OPÇÕES DE CORES';
        });
      }
    }
  });
  
  // Previne zoom apenas nos dots
  const dots = document.querySelectorAll('.carousel-dot');
  dots.forEach(dot => {
    dot.addEventListener('touchstart', function(e) {
      e.preventDefault();
    });
  });
});